import Greeting from "./pages/Greeting.svelte";
import Bundles from "./pages/Bundles.svelte";
import Uploader from "./pages/Uploader.svelte";
import Builder from "./pages/Builder.svelte";
import Props from "./pages/Props.svelte";
import Materials from "./pages/Materials.svelte";
import Resources from "./pages/Resources.svelte";
import Locomotives from "./pages/Locomotives.svelte";
import Railcars from "./pages/Railcars.svelte";
import Levels from "./pages/Levels.svelte";
import GameBuilds from "./pages/GameBuilds.svelte";
import Perks from "./pages/Perks.svelte";
import Productions from "./pages/Productions.svelte";
const routes = {
    "/": Greeting,
    "/bundles": Bundles,
    "/materials": Materials,
    "/uploader": Uploader,
    "/builder": Builder,
    "/props": Props,
    "/resources": Resources,
    "/locomotives": Locomotives,
    "/railcars": Railcars,
    "/perks": Perks,
    "/levels": Levels,
    "/game_builds": GameBuilds,
    "/productions": Productions,
};
export { routes };
